import { usePairs } from '@/store/pairs';
import { useShallow } from 'zustand/shallow';

export function usePairsByIndex(pairIndex: number | string) {
    const pairs = usePairs(useShallow((state) => state.data));
    const pair = pairs.find((item) => item.pairIndex === Number(pairIndex));
    return pair;
}
